import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Provider } from 'react-redux'
import MainRoutes from '../routes'
import { Router, Route } from 'react-router-dom'
import AppStyles from 'commonComps/AppStyles'
import { withErrorBoundary } from '@vmockinc/dashboard/Common/commonComps/ErrorBoundary'

const Root = ({ store, history }) => (
  <Provider store={store}>
    <Router history={history}>
      <AppStyles />
      <WrapRoute path="/aspire/" component={MainRoutes} />
    </Router>
  </Provider>
)

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

const WrapRoute = ({ component: Component, ...rest }) => {
  const ComponentWrapper = withErrorBoundary(Component, 'aspire', '')
  return <Route {...rest} component={ComponentWrapper} />
}

export default Root
